import { useQuery } from 'react-query';

import { authorizedGet } from '../authorizedApi';

export const useFetchAccountsThatAccepted = (invitationid: string) => {
  const { isLoading, data, isError, error, refetch } = useQuery<any, Error>(
    `accountsThatAccepted--${invitationid}`,
    async () => {
      const invitationUrl: RequestInfo = `/invitation/${invitationid}/accounts`;

      const getAccountsThatAccepted = authorizedGet(invitationUrl);
      const response = await getAccountsThatAccepted();

      const data = await response.json();

      return data;
    },
    {
      retry: false,
    }
  );

  return {
    isLoading,
    isError,
    error,
    accounts: data,
    refetch,
  };
};
